//export const BASE_URL = 'https://localhost:5001/';
export const BASE_URL = 'https://api.vg.dk/';
//'http://18.203.5.207:5000/'; //'http://46.101.149.207:5000/';//'http://vanlosegaard.fluency.dk:5000/';
//  export const BASE_URL = 'http://18.203.5.207:5000/'; //'http://46.101.149.207:5000/';//'http://vanlosegaard.fluency.dk:5000/';